import { useQueryClient } from "@tanstack/react-query";
import { useMesfRealtime } from "@dexteel/mesf-core";

const SP_TO_QUERY_KEYS: Record<string, readonly string[][]> = {
  // Data Entry
  "RBD.GetChemistriesByHeatId": [["lab-chemistries"]],
  "RBD.GetSampleAttributesByChemistryId": [["lab-sample-attributes"]],
  "LAB.DEGetProcess": [["lab-process"]],
  // Chemistries Report
  "LAB.GetReportChemistrySamples": [["chemistry-samples"]],
  // Catalogs
  "LAB.GetCatSampleTypes": [["lab-catalog-sample-types"]],
  "LAB.GetCatElements": [["lab-catalog-elements"]],
};

export const useRealtimeInvalidation = () => {
  const queryClient = useQueryClient();

  useMesfRealtime({
    onReceiveMessage: (_author: string, message: string) => {
      const queryKeys = SP_TO_QUERY_KEYS[message];
      if (queryKeys) {
        queryKeys.forEach((queryKey) => {
          queryClient.invalidateQueries({ queryKey });
        });
      }
    },
  });
};
